<template lang="pug">
#onlyOfficeContainer(v-if="viewType === 'onlyOffice'")
  onlyoffice(:fileInfo="fileInfo")
#docContainer(v-else v-loading='loading' element-loading-text='文档加载中...' element-loading-background='rgba(0, 0, 0, 0.5)')
  .content(ref="txt")
    .txt(v-html='content')
  application(ref='docApplication' type="txt" v-if="docloaded")
</template>

<script>
import { scanUrl, creatWatermarkUserInfo, addWaterMarker } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/CommonDP/mongeView/application.vue";
import onlyoffice from "@/CommonDP/mongeView/docmentView/onlyoffice.vue";
export default {
  components: { application, onlyoffice },
  data() {
    return {
      inputText: "",
      loading: true,
      content: "",
      docloaded: false,
      viewType: "officeOnline",
      fileInfo: {}
    };
  },
  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  created () {
    this.getFileInfo();
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" , viewType} = this.$route.query;
      this.viewType = viewType;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      // 查询文件信息, 并设置参数
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const fileInfo = { fileId, fileVersion, sharerId, i, title: data.fileName, ...data };
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      if (this.viewType === "onlyOffice") {
      // 设置 onlyOffice 的参数
        this.fileInfo = fileInfo;
      } else {
        await this.getRequestData(sharerId);
      }      
    },
    getRequestData(sharerId) {
      const otherData = this.docmentData;
      const txtUrl = scanUrl(otherData.fileId, otherData.fileVersion, sharerId);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = txtUrl;
      document.getElementById('docContainer').appendChild(iframe);
      iframe.onload = () => {
        const content = iframe.contentWindow.document.body.innerHTML;
        this.content = content;
        addWaterMarker(document.body, creatWatermarkUserInfo());
        iframe.remove();
        this.loading = false;
        this.docloaded = true;
      };
      iframe.onerror = (e) => { this.loadingTxt = '文档加载失败'; };
    }
  }

};
</script>
<style rel="stylesheet/scss" lang="scss">
#onlyOfficeContainer {
  padding: 0 !important;
  width: 100%;
  height: calc(100vh - 180px);
}
</style>
<style lang="scss" scoped>
#docContainer{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.content{
  width:100%;
  height:100%;
  background-color: #E9FAFF;
  padding:7px 14px;
  color: #555;
  overflow-y:auto;
  z-index: 0.9;
}
</style>
